import { ThemeProvider } from "@/components/theme-provider"
import { TopNavigation } from "@/components/top-navigation"
import { MapExplorer } from "@/components/map-explorer"
import { DataHarvestPage } from "@/pages/data-harvest"
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from "react"
import { ensureAnonAuth } from "./lib/firebase"

function App() {
  useEffect(() => {
    ensureAnonAuth().catch(console.error);
  }, []);

  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
      <BrowserRouter>
        <div className="min-h-screen bg-background font-sans">
          <TopNavigation />
          <div className="flex">
            {/* <Sidebar /> */}
            <main className="flex-1">
              <Routes>
                <Route path="/map" element={<MapExplorer />} />
                <Route path="/flood-events" element={<DataHarvestPage />} />
                <Route path="/" element={<Navigate to="/map" replace />} />
                <Route path="*" element={<Navigate to="/map" replace />} />
              </Routes>
            </main>
          </div>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App